import ApiService from '~/utils/ApiService';

export const UPDATE_ORG_FEATURES_REQUEST = 'UPDATE_ORG_FEATURES_REQUEST';
export const UPDATE_ORG_FEATURES_SUCCESS = 'UPDATE_ORG_FEATURES_SUCCESS';
export const UPDATE_ORG_FEATURES_FAILURE = 'UPDATE_ORG_FEATURES_FAILURE';

export const getOrgFeatures = org => dispatch => {
  dispatch(getOrgFeatureRequest());

  ApiService.get(`/orgs/${org.id}/features`)
    .then(features => {
      dispatch(getOrgFeaturesSuccess(features));
    })
    .catch(error => {
      dispatch(getOrgFeaturesFailure(error));
    });
};

export const getOrgFeatureRequest = () => ({
  type: UPDATE_ORG_FEATURES_REQUEST,
});

export const getOrgFeaturesFailure = error => ({
  type: UPDATE_ORG_FEATURES_FAILURE,
  message: error.message || 'Something went wrong. Please try again',
});

export const getOrgFeaturesSuccess = features => ({
  type: UPDATE_ORG_FEATURES_SUCCESS,
  features,
});
